import { TypedDocumentNode, gql } from '@apollo/client';
import { useState } from 'react';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { RaffleTicket } from '@sorare/core/src/atoms/icons/RaffleTicket';
import { isType, randomizedPollInterval } from '@sorare/core/src/gql';
import { useQuery } from '@sorare/core/src/hooks/graphql/useQuery';

import { EmirateVIPRaffleModal } from 'components/promotions/EmirateVIPRaffleModal';

import {
  RaffleTicketBalanceButtonQuery,
  RaffleTicketBalanceButtonQueryVariables,
} from './__generated__/index.graphql';

const query = gql`
  query RaffleTicketBalanceButtonQuery {
    shopItems(sport: NBA, types: [RAFFLE], unlockedOnly: true) {
      nodes {
        ... on RaffleShopItem {
          id
          myBalance
        }
      }
    }
  }
` as TypedDocumentNode<
  RaffleTicketBalanceButtonQuery,
  RaffleTicketBalanceButtonQueryVariables
>;

const POLL_INTERVAL = randomizedPollInterval(5);

export const RaffleTicketBalanceButton = () => {
  const [raffleTicketDialogOpen, setRaffleTicketDialogOpen] = useState(false);

  const { data } = useQuery(query, {
    pollInterval: POLL_INTERVAL,
  });

  const tasks = data?.shopItems.nodes || [];
  const raffleItems = tasks.filter(t => isType(t, 'RaffleShopItem'));
  const balance = raffleItems[0]?.myBalance || 0;

  return (
    <>
      <Button
        onClick={() => setRaffleTicketDialogOpen(true)}
        color="transparent"
        size="medium"
      >
        <RaffleTicket width={12} />
        {balance}
      </Button>
      <EmirateVIPRaffleModal
        open={raffleTicketDialogOpen}
        balance={balance}
        onClose={() => setRaffleTicketDialogOpen(false)}
      />
    </>
  );
};
